import React from "react";

export function TrendStartIcon({ size = 20, fontSize = 12, style }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        textAlign: "center",
        color: "#6b7280",
        fontSize,
        lineHeight: 1,
        ...style,
      }}
    >
      ●
    </span>
  );
}

export function TrendUpIcon({ size = 20, fontSize = 12, style }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        textAlign: "center",
        color: "#16a34a",
        fontSize,
        lineHeight: 1,
        ...style,
      }}
    >
      ▲
    </span>
  );
}

export function TrendDownIcon({ size = 20, fontSize = 12, style }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        textAlign: "center",
        color: "#dc2626",
        fontSize,
        lineHeight: 1,
        ...style,
      }}
    >
      ▼
    </span>
  );
}

export function NeutralTrendIcon({ size = 20, fontSize = 14, style }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        textAlign: "center",
        color: "#6b7280",
        fontSize,
        lineHeight: 1,
        ...style,
      }}
    >
      —
    </span>
  );
}

export function TrendIcon({ trend, ...props }) {
  if (trend === "positive") return <TrendUpIcon {...props} />;
  if (trend === "negative") return <TrendDownIcon {...props} />;
  if (trend === "neutral") return <NeutralTrendIcon {...props} />;
  return <TrendStartIcon {...props} />;
}

